import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"

import {
  getGatewayNoticeList
} from "../../apiCloud/notice"
import {
  pUrl
} from "@/api/baseURL.js";
export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      isView: false, //新闻是否被查看
      noticeList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      isJx: false,

    }
  },
  created() {
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
    this.getNoticeList(1)

    // var pUrl=window.location.href;
    // // 是否是江西代理商访问
    //     if(pUrl=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http:/jx.eceping.net:8080"){//jx.eceping.net域名时,显示关于我们
    //     console.log(1111,this.isJx)
    //     this.isJx=true;
    // }
  },
  mounted() {
    var publicCourse = document.getElementById("noticeUl")
    // var noticeUl=document.getElementsByClassName("noticeUl")
    console.log(1111, document.getElementsByClassName("noticeUl"))
    // noticeUl.style.minHeight=document.body.scrollHeight-120+"px"
    publicCourse.style.minHeight = document.body.scrollHeight - 90 + "px"
    console.log(666, $(".noticeUl").width())
  },
  methods: {
    //获取消息列表
    getNoticeList() {
      $('html,body').animate({
        scrollTop: '0px'
      }, 500)
      let data = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      getGatewayNoticeList(data).then(res => {
        // console.log("通知列表数据",res)
        if (res.code == 200) {
          this.noticeList = res.rows
          this.total = res.total

        } else if (res.code == 2202) {
          this.$message.error(res.message)
          localStorage.removeItem('tokenId');
          this.$router.push({
            path: "/login"
          })
        }
      })
    },
    //通知详情
    GotoNoticeDetail(id) {
      this.$router.push({
        path: "/noticeDetail",
        query: {
          noticeId: id,
        }
      });
    },
    currentChange(page) {
      this.pageNum = page
      console.log(page)
      this.getNoticeList()
    },

    setBoxHeight() {

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/notice/notice.js